// eslint-disable-next-line import/no-cycle
import request from '@/utils/request'
import md5 from 'blueimp-md5'

/**
 * @apiName 用户登录
 */
export function login(username, code) {
  return request({
    url: '/admin/v1/vehicle/user/token/create',
    method: 'post',
    data: {
      username,
      smsCode: code,
    },
  })
}

/**
 * @apiName 通过 token 置换用户信息
 */
export function getInfoByToken() {
  return request({
    url: '/admin/v1/vehicle/user/token/currentUser',
    method: 'post',
    data: {},
  })
}


/**
 * @apiName 刷新 token
 */
export function refreshToken() {
  return request({
    url: '/admin/v1/vehicle/manage/token/refresh',
    method: 'post',
    data: {},
  })
}

/**
 * @apiName 退出登录
 */
export function logout(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/token/release',
    method: 'post',
    data,
  })
}

/**
 * @apiname 商城登录授权
 * @param {string} phone 手机号
 */
export function purchaseMallLogIn(data = {}) {
  return request({
    url: '/admin/v1/maintenance/purchase/mall/logIn',
    method: 'post',
    data,
  })
}

/**
 * @apiname 商城退出登录
 * @param {string} phone 手机号
 */
export function purchaseMallLogOut(data = {}) {
  return request({
    url: '/admin/v1/maintenance/purchase/mall/logOut',
    method: 'post',
    data,
  })
}

/**
 * @apiname 解绑微信
 */
export function unbindWechat(data = {}) {
  return request({
    url: '/admin/v1/vehicle/wechat/unbind',
    method: 'post',
    data,
  })
}
